import * as z from 'zod';

import { domainQuerySchema } from './domain-query-schema';
import { hostingManagementFormSchema } from './hosting-management-schema';
import { registrarManagementFormSchema } from './registrar-management-schema';

export const domainFormSchema = domainQuerySchema
  .pick({
    id: true,
    name: true,
    registrar: true,
    infrastructure: true,
    client: true,
    application: true,
  })
  .extend({
    registrar_management: registrarManagementFormSchema.nullable(),
    dns_management: z.string(),
    registrar_username: z.string(),
    registrar_password: z.string(),
    registrar_pin: z.string(),
    expiration_date: z.string(),
    registrar_notes: z.string(),

    hosting_management: hostingManagementFormSchema.nullable(),
    deployment_path: z.string(),
    hosting_notes: z.string(),
  });

export type DomainFormSchema = z.infer<typeof domainFormSchema>;
